export const AUTOMATION_ACTIVATION_INTRO_COPY =
  'Review readiness below, then activate the default automation bundle when your league is eligible. Archive auto-publish stays off — commissioner review is still required before anything goes live on the archive.';

export const AUTOMATION_ACTIVATION_UNPAID_COPY =
  'An active LSC subscription is required before automations can be activated. Complete billing in the Subscription step first.';

export const AUTOMATION_ACTIVATION_SCHEDULE_BLOCKED_COPY =
  'Connect your schedule source and sync the current week with active games before activating automations.';

export const AUTOMATION_ACTIVATION_ZERO_BROADCASTERS_COPY =
  'At least one eligible Twitch broadcaster with live detection coverage is required before activation.';

export const AUTOMATION_ACTIVATION_PENDING_OPERATOR_COPY =
  'Your activation request is saved. Production automation rollout is still finishing on Scoutlytics infrastructure. Monitor progress in Command Center.';

export const AUTOMATION_ACTIVATION_ENTITLEMENT_BRIDGE_DISABLED_COPY =
  'Your activation request is saved. Paid automation runtime is not live yet — Scoutlytics is finishing the production rollout. Your bundle will start automatically once rollout completes. Monitor progress in Command Center.';

export const AUTOMATION_ACTIVATION_ACTIVE_COPY =
  'Your default automation bundle is active. Use Command Center to monitor live detection, archive review, and any items that need attention.';

export const AUTOMATION_ACTIVATION_AUTOPUBLISH_OFF_COPY =
  'Archive auto-publish is off. Verified games still flow through commissioner review before publish.';

export const AUTOMATION_ACTIVATION_BUNDLE_TITLE = 'Default automation bundle';

export const AUTOMATION_ACTIVATION_CHECKLIST_TITLE = 'Activation readiness';

export const AUTOMATION_ACTIVATION_COMMAND_CENTER_COPY =
  'Open Command Center for lane-by-lane status, live detection, and review queue readiness.';

export function automationActivationStatusLabel(status: string): string {
  switch (status) {
    case 'ready_to_activate':
      return 'Ready to activate';
    case 'activation_requested':
      return 'Activation requested';
    case 'active':
      return 'Active';
    case 'pending_operator_enablement':
      return 'Pending rollout';
    case 'entitlement_bridge_disabled':
      return 'Awaiting production rollout';
    case 'locked_unpaid':
      return 'Blocked by subscription';
    case 'blocked':
      return 'Setup incomplete';
    default:
      return 'Setup incomplete';
  }
}
